import { Spinner } from "@workspace/ui/components/spinner";

export function FestivalLoadingState() {
	return (
		<div className="flex min-h-screen flex-col p-4">
			<div className="flex flex-1 flex-col items-center justify-center p-4">
				<Spinner size="xl" />
			</div>
		</div>
	);
}
